	<!--begin::Signin-->
	<div class="login">
		<div class="info">
			<h3 class="title">{{'AUTH.LOGIN.HELLO' | translate}}</h3>
			<p class="details">
				{{'AUTH.LOGIN.LOGIN_DATA' | translate}}
			</p>
		</div>

		<kt-auth-notice></kt-auth-notice>

		<!--begin::Form-->
		<form class="login-form" [formGroup]="loginForm" autocomplete="off">

			<div class="form-group">
                <mat-label style="color:#00A9A5;font-weight: 500;">{{ 'AUTH.INPUT.LOGIN_BY' | translate }} &nbsp;&nbsp;&nbsp;</mat-label>
				<mat-radio-group formControlName="login_by">
					<mat-radio-button [value]="1">{{ 'AUTH.INPUT.EMPLOYEE_NUMBER' | translate }}</mat-radio-button>
					<mat-radio-button [value]="2">{{ 'AUTH.INPUT.MOBILE' | translate }}</mat-radio-button>
				  </mat-radio-group>
			</div>
			<div class="form-group">

				<mat-form-field *ngIf="loginForm.controls.login_by.value === 2">
					<mat-label>{{ 'AUTH.INPUT.MOBILE' | translate }}</mat-label>
					<input matInput type="text" placeholder="{{ 'AUTH.INPUT.MOBILE' | translate }}" formControlName="mobile" autocomplete="off"/>
					<mat-icon matSuffix>phone_iphone</mat-icon>
					<mat-error *ngIf="isControlHasError('mobile','required')">
						<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('mobile','minlength')">
						<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 7</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('mobile','maxlength')">
						<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 16</strong>
					</mat-error>
				</mat-form-field>

				<mat-form-field *ngIf="loginForm.controls.login_by.value === 1">
					<mat-label>{{ 'AUTH.INPUT.EMPLOYEE_NUMBER' | translate }}</mat-label>
					<input matInput type="text" placeholder="{{ 'AUTH.INPUT.EMPLOYEE_NUMBER' | translate }}" formControlName="employee_number" autocomplete="off"/>
					<mat-icon matSuffix>perm_identity</mat-icon>
					<mat-error *ngIf="isControlHasError('employee_number','required')">
						<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('employee_number','minlength')">
						<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 4</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('employee_number','maxlength')">
						<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 10</strong>
					</mat-error>
				</mat-form-field>
			</div>
			<div class="form-group">
				<mat-form-field>
					<mat-label>{{ 'AUTH.INPUT.PASSWORD' | translate }}</mat-label>
					<input matInput type="password" placeholder="{{ 'AUTH.INPUT.PASSWORD' | translate }}" formControlName="password" autocomplete="off"/>
					<mat-icon matSuffix>lock</mat-icon>
					<mat-error *ngIf="isControlHasError('password','required')">
						<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('password','minlength')">
						<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('password','maxlength')">
						<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 100</strong>
					</mat-error>
				</mat-form-field>
			</div>
			<!--begin::Action-->
			<div>
				<a hidden href="javascript:;" routerLink="/auth/forgot-password" class="kt-link kt-login__link-forgot">
					{{ 'AUTH.GENERAL.FORGOT_BUTTON' | translate }}
				</a>
				<button (click)="submit()" [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading}" id="kt_login_signin_submit" class="btn btn-green btn-block btn-elevate">{{ 'AUTH.LOGIN.BUTTON' | translate }}</button>
			</div>
			<!--end::Action-->
		</form>
		<!--end::Form-->
	</div>
	<!--end::Signin-->
